import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Link from '../../../elements/Link';
import Text from '../../../elements/Text';
import Separator from '../atoms/Separator';

interface Props {
  showBusStation?: boolean;
  showSeparator?: boolean;
  showStationLink?: boolean;
  showCityLink?: boolean;
  moreInformationLink?: string;
  showTypeOfJourney?: boolean;
  typeOfJourneyKey?: string;
  title?: string;
  separatorKey?: string;
  cityLink?: string;
  city?: $TSFixMe;
  locationTypeStyles?: StyledProps;
  typeOfJourneyKeyStyles?: StyledProps;
  busStationStyles?: StyledProps;
  separatorStyles?: StyledProps;
  cityLinkStyles?: StyledProps;
  locationType?: 'departure' | 'arrival' | 'busStation';
  onStationClick?: (station: $TSFixMe, callToActionLabel: string) => void;
}

function DepartureArriveInfo({
  locationTypeStyles = {},
  showTypeOfJourney = false,
  showBusStation = true,
  showSeparator = false,
  showCityLink = false,
  showStationLink = true,
  moreInformationLink = '#',
  typeOfJourneyKey = 'cmp-bus-directory-map-departure',
  title = '',
  separatorKey = 'minus',
  cityLink = '',
  city = {},
  typeOfJourneyKeyStyles,
  busStationStyles,
  separatorStyles,
  cityLinkStyles,
  locationType,
  onStationClick,
  ...props
}: StyledProps<Props>) {
  const { translate } = useContext(Context);
  return (
    <Box
      className="station-item-bus-station"
      display="flex"
      fontWeight="bold"
      marginBottom="3"
      fontSize="14px"
      {...props}
    >
      {showTypeOfJourney && (
        <Text {...typeOfJourneyKeyStyles}>{translate(typeOfJourneyKey, 'Departing from')}</Text>
      )}
      {showBusStation && (
        <Box>
          <Text {...locationTypeStyles}>
            {locationType &&
              translate(
                `cmp-bus-directory-info-${locationType}`,
                `cmp-bus-directory-info-${locationType}`
              )}
          </Text>
          {showStationLink ? (
            <Link
              href={moreInformationLink}
              textColor="black"
              {...busStationStyles}
              onClick={() => onStationClick?.(props, 'tile')}
            >
              {title}
            </Link>
          ) : (
            <Text {...busStationStyles}>{title}</Text>
          )}
        </Box>
      )}
      {showSeparator && <Separator {...separatorStyles} content={separatorKey} />}
      {showCityLink && (
        <Link href={cityLink} {...cityLinkStyles}>
          {city.fullName}
        </Link>
      )}
    </Box>
  );
}

DepartureArriveInfo.componentName = 'DepartureArriveInfo';

export default DepartureArriveInfo;
